(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel-image-and-text"] && !Shopify.designMode) return;
  try {
    
    (function ($) {


        $('.litter-genie-custom-carousel-image-and-text').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            autoplaySpeed: 3000,
            prevArrow:'<button id="button-prev" type="button" class="slick-prev slick-arrow" aria-label="Previous" style="border-color: #3c2568!important"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"></path></svg></button>',
            nextArrow:'<button id="button-next" type="button" class="slick-next slick-arrow" aria-label="Next" style="border-color: #3c2568!important"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"></path></svg></button>',
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                    slidesToShow: 1,
                    }
                }
            ]
        });

    })(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cat-experts-section"] && !Shopify.designMode) return;
  try {
    
$('.expert-videos').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg width="64" height="64" viewBox="0 0 32 32"><path d="M11.5,26c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l8.3-8.3l-8.3-8.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l9,9c0.4,0.4,0.4,1,0,1.4l-9,9C12,25.9,11.8,26,11.5,26z" fill="white"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="64" height="64" viewBox="0 0 32 32"><path d="M11.5,26c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l8.3-8.3l-8.3-8.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l9,9c0.4,0.4,0.4,1,0,1.4l-9,9C12,25.9,11.8,26,11.5,26z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-banner-slider"] && !Shopify.designMode) return;
  try {
    


  $('.custom-hero-banner-slider').slick({
    infinite: true,
    fade: true,
    arrows: false,
    dots: true,
    dotsClass: "custom-hero-banner-slider-dots slick-dots ",
    autoplay: true,
    autoplaySpeed: 3000,
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-section-litter-genie"] && !Shopify.designMode) return;
  try {
    
  $('.custom-reviews-carousel').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplaySpeed: 3000,
            prevArrow:'<button type="button" class="slick-prev slick-arrow" aria-label="Previous" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"></path></svg></button>',
            nextArrow:'<button type="button" class="slick-next slick-arrow" aria-label="Next" style=""><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"></path></svg></button>',
            responsive: [
    {
      // For screens smaller than 768px (mobile)
      breakpoint: 768,
      settings: {
        slidesToShow: 1, // Show 1 slide
        slidesToScroll: 1, // Scroll 1 slide at a time
        infinite: true, // Infinite scroll
        arrows: true,
      }
    },
    {
      // For screens larger than 768px (tablet and desktop)
      breakpoint: 1024,
      settings: {
        slidesToShow: 2, // Show 3 slides
        slidesToScroll: 1,
      }
    }
  ]
        });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tabs-section"] && !Shopify.designMode) return;
  try {
    
    $( ".product-tab-item.features" ).click(function() {
      $(".how-to-use-info").removeClass('product-active');
      $(".compatible-info").removeClass('product-active');
      $(".review-info").removeClass('product-active');
      $(".features-info").addClass('product-active');
      $(".product-tab-item.features").addClass('is-active');
      $(".compatible").removeClass('is-active');
      $(".how-to-use").removeClass('is-active');
      $(".review").removeClass('is-active');
  });

       $( ".product-tab-item.review" ).click(function() {
      $(".features-info").removeClass('product-active');
      $(".how-to-use-info").removeClass('product-active');
      $(".compatible-info").removeClass('product-active');
      $(".review-info").addClass('product-active');
         $(".product-tab-item.features").removeClass('is-active');
      $(".compatible").removeClass('is-active');
      $(".how-to-use").removeClass('is-active');
      $(".review").addClass('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-landing-page"] && !Shopify.designMode) return;
  try {
    
$('.elp-videos-container .expert-videos').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><svg width="64" height="64" viewBox="0 0 32 32"><path d="M11.5,26c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l8.3-8.3l-8.3-8.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l9,9c0.4,0.4,0.4,1,0,1.4l-9,9C12,25.9,11.8,26,11.5,26z" fill="white"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="64" height="64" viewBox="0 0 32 32"><path d="M11.5,26c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l8.3-8.3l-8.3-8.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l9,9c0.4,0.4,0.4,1,0,1.4l-9,9C12,25.9,11.8,26,11.5,26z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-02"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-02');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

// for country select and language select

    class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-03"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-03');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-04"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-04');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.HeaderAnnouncement = document.getElementById('shopify-section-announcement-bar').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (document.getElementById('shopify-section-announcement-bar') && this.HeaderAnnouncement > 0) {
                var headerHeight = this.header.clientHeight + this.HeaderAnnouncement
            } else {
                var headerHeight = this.header.clientHeight
            }
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (headerHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
            if(!$('.header-04').hasClass('style_3')){
                $('.vertical-menu').addClass('hide');
            }
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
            if(!$('.header-04').hasClass('style_3')){
                if ($('.vertical-menu').hasClass('open')) {
                    $('.vertical-menu').removeClass('hide');
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-05"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-05');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-06"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-06');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }
        
        disconnectedCallback() {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (window.innerWidth > 1200 && document.querySelector('.layout_search--style2')) {
                    const openDetailsElement = this.querySelector('details[open]');
                    if (openDetailsElement) {
                        const summaryElement = openDetailsElement.querySelector('summary');
                        openDetailsElement.removeAttribute('open');
                        summaryElement.focus();
                        document.body.classList.remove('open_search');
                    }
                }
                if (!document.body.classList.contains('cart-sidebar-show') && 
                    !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                    }
                    this.check = true;
                    this.currentScrollTop = scrollTop;
                }
            } else {
                this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-07"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-07');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
                }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-08"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-08');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-09"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-09');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-10"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-10');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-section"] && !Shopify.designMode) return;
  try {
    

        if ($('.compatible-with .item-product').length < 3) {
    $('.compatible-with').addClass('less-product');
  }
  if ($('.compatible-with .item-product').length > 3) {
    $('.compatible-with .item-product').addClass('more-product');
  }

 
  
    
      $( ".product-tab-item.features" ).click(function() {
        $(".how-to-use-info").removeClass('product-active');
        $(".compatible-info").removeClass('product-active');
        $(".review-info").removeClass('product-active');
        $(".features-info").addClass('product-active');
        $(".product-tab-item.features").addClass('is-active');
        $(".compatible").removeClass('is-active');
        $(".how-to-use").removeClass('is-active');
        $(".review").removeClass('is-active');
    });
  
      $( ".product-tab-item.how-to-use" ).click(function() {
        $(".features-info").removeClass('product-active');
        $(".compatible-info").removeClass('product-active');
        $(".review-info").removeClass('product-active');
        $(".how-to-use-info").addClass('product-active');
        $(".product-tab-item.features").removeClass('is-active');
        $(".compatible").removeClass('is-active');
        $(".how-to-use").addClass('is-active');
        $(".review").removeClass('is-active');
    });
  
       $( ".product-tab-item.compatible" ).click(function() {
        $(".features-info").removeClass('product-active');
        $(".how-to-use-info").removeClass('product-active');
        $(".review-info").removeClass('product-active');
        $(".compatible-info").addClass('product-active');
         $(".product-tab-item.features").removeClass('is-active');
        $(".compatible").addClass('is-active');
        $(".how-to-use").removeClass('is-active');
        $(".review").removeClass('is-active');
    });
  
         $( ".product-tab-item.review" ).click(function() {
        $(".features-info").removeClass('product-active');
        $(".how-to-use-info").removeClass('product-active');
        $(".compatible-info").removeClass('product-active');
        $(".review-info").addClass('product-active');
           $(".product-tab-item.features").removeClass('is-active');
        $(".compatible").removeClass('is-active');
        $(".how-to-use").removeClass('is-active');
        $(".review").addClass('is-active');
    });

    // Video Popup Code

     $('#video-popup').click(function(){
        $('#popup').fadeIn();
    });

    $('.close, .popup').click(function(){
        // Pause the video before closing the popup
        $('#popup iframe').each(function(){
            $(this).attr('src', $(this).attr('src'));
        });
        $('#popup').fadeOut();
    });

    $('.popup-content').click(function(event){
        event.stopPropagation();
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PROVINCES = {
      AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick',
      NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', NT: 'Northwest Territories',
      NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec',
      SK: 'Saskatchewan', YT: 'Yukon'
    };
    var GEO_CACHE_PREFIX = 'lgsl_geo_v1_';
    var GEO_CACHE_TTL = 1000 * 60 * 60 * 24 * 30; // 30 days (Google ToS caching window)
    var mapsLoadPromise = null;

    function loadMapsApi(key) {
      if (mapsLoadPromise) return mapsLoadPromise;
      mapsLoadPromise = new Promise(function (resolve, reject) {
        if (window.google && window.google.maps) return resolve();
        var cb = '__lgslMapsReady_' + Math.random().toString(36).slice(2);
        window[cb] = function () { delete window[cb]; resolve(); };
        var s = document.createElement('script');
        s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&callback=' + cb;
        s.async = true;
        s.onerror = function () { reject(new Error('Maps JS failed to load')); };
        document.head.appendChild(s);
      });
      return mapsLoadPromise;
    }

    function cacheGet(k) {
      try {
        var raw = localStorage.getItem(GEO_CACHE_PREFIX + k);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (Date.now() - obj.t > GEO_CACHE_TTL) { localStorage.removeItem(GEO_CACHE_PREFIX + k); return null; }
        return obj.v;
      } catch (e) { return null; }
    }

    function cacheSet(k, v) {
      try { localStorage.setItem(GEO_CACHE_PREFIX + k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
    }

    function haversineKm(a, b) {
      var R = 6371, rad = Math.PI / 180;
      var dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
    }

    function normalizePostal(v) {
      var p = (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(p)) return p.slice(0, 3) + ' ' + p.slice(3);
      if (/^[A-Z]\d[A-Z]$/.test(p)) return p; // FSA-only accepted
      return null;
    }

    function fullAddress(store) {
      return store.address + ', ' + store.city + ', ' + store.province + (store.postal ? ' ' + store.postal : '') + ', Canada';
    }

    function directionsUrl(store) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(fullAddress(store));
    }

    function track(event, data) {
      window.dataLayer = window.dataLayer || [];
      var payload = Object.assign({ event: event }, data || {});
      window.dataLayer.push(payload);
    }

    function init(root) {
      if (root.__lgslInit) return;
      root.__lgslInit = true;

      var apiKey = (root.getAttribute('data-api-key') || '').trim();
      var toggleBtns = root.querySelectorAll('.lg-locator__toggle-btn');
      var panels = root.querySelectorAll('[data-panel]');

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-mode');
          toggleBtns.forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== mode; });
          track('store_locator_mode', { locator_mode: mode });
          if (mode === 'instore') activateInstore();
        });
      });

      // Online retailer click tracking
      root.querySelectorAll('.lg-locator__brand-link').forEach(function (a) {
        a.addEventListener('click', function () {
          track('store_locator_retailer_click', { locator_retailer: a.getAttribute('data-retailer') || '' });
        });
      });

      // ---------- In-store ----------
      var dataEl = root.querySelector('[data-stores-json]');
      if (!dataEl) return;
      var stores;
      try { stores = JSON.parse(dataEl.textContent); } catch (e) { stores = []; }

      var resultsEl = root.querySelector('[data-results]');
      var mapWrap = root.querySelector('[data-map-wrap]');
      var mapEl = root.querySelector('[data-map]');
      var form = root.querySelector('[data-postal-form]');
      var input = root.querySelector('[data-postal-input]');
      var msgEl = root.querySelector('[data-search-msg]');
      var resetBtn = root.querySelector('[data-reset-btn]');
      var map = null, markers = [], userMarker = null, geocoder = null;
      var instoreActivated = false;

      function showMsg(text) { msgEl.textContent = text; msgEl.hidden = false; }
      function clearMsg() { msgEl.hidden = true; msgEl.textContent = ''; }

      function cardHtml(store, distanceKm) {
        var suffix = root.getAttribute('data-distance-suffix') || 'km away';
        return '<div class="lg-locator__card">' +
          '<p class="lg-locator__card-name">' + escapeHtml(store.name) + '</p>' +
          '<p class="lg-locator__card-address">' + escapeHtml(store.address) + '<br>' +
          escapeHtml(store.city) + ', ' + escapeHtml(store.province) + (store.postal ? ' ' + escapeHtml(store.postal) : '') + '</p>' +
          (distanceKm != null ? '<span class="lg-locator__card-distance">' + distanceKm.toFixed(1) + ' ' + escapeHtml(suffix) + '</span>' : '') +
          '<a class="lg-locator__card-directions" href="' + directionsUrl(store) + '" target="_blank" rel="noopener">Get Directions</a>' +
          '</div>';
      }

      function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function renderGrouped() {
        var groups = {};
        stores.forEach(function (s) { (groups[s.province] = groups[s.province] || []).push(s); });
        var codes = Object.keys(groups).sort(function (a, b) {
          return (PROVINCES[a] || a).localeCompare(PROVINCES[b] || b);
        });
        var html = '';
        codes.forEach(function (code) {
          groups[code].sort(function (a, b) { return a.city.localeCompare(b.city); });
          html += '<h3 class="lg-locator__province-title">' + escapeHtml(PROVINCES[code] || code) + '</h3>';
          html += '<div class="lg-locator__cards">' + groups[code].map(function (s) { return cardHtml(s, null); }).join('') + '</div>';
        });
        resultsEl.innerHTML = html;
        resetBtn.hidden = true;
      }

      function renderSorted(origin) {
        var withCoords = stores.filter(function (s) { return s.lat != null && s.lng != null; });
        var noCoords = stores.filter(function (s) { return s.lat == null || s.lng == null; });
        withCoords.forEach(function (s) { s.__d = haversineKm(origin, { lat: s.lat, lng: s.lng }); });
        withCoords.sort(function (a, b) { return a.__d - b.__d; });
        var html = '<div class="lg-locator__cards">' +
          withCoords.map(function (s) { return cardHtml(s, s.__d); }).join('') +
          noCoords.map(function (s) { return cardHtml(s, null); }).join('') +
          '</div>';
        resultsEl.innerHTML = html;
        resetBtn.hidden = false;
      }

      function initMap() {
        if (!apiKey || map || !mapEl) return Promise.resolve();
        return loadMapsApi(apiKey).then(function () {
          mapWrap.hidden = false;
          map = new google.maps.Map(mapEl, {
            center: { lat: 56.13, lng: -96.0 }, // Canada
            zoom: 4,
            mapTypeControl: false,
            streetViewControl: false
          });
          geocoder = new google.maps.Geocoder();
          var bounds = new google.maps.LatLngBounds();
          var info = new google.maps.InfoWindow();
          stores.forEach(function (s) {
            if (s.lat == null || s.lng == null) return;
            var m = new google.maps.Marker({ map: map, position: { lat: s.lat, lng: s.lng }, title: s.name });
            m.addListener('click', function () {
              info.setContent(
                '<strong>' + escapeHtml(s.name) + '</strong><br>' + escapeHtml(s.address) + '<br>' +
                escapeHtml(s.city) + ', ' + escapeHtml(s.province) +
                '<br><a href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Get Directions</a>'
              );
              info.open(map, m);
            });
            markers.push(m);
            bounds.extend(m.getPosition());
          });
          if (!bounds.isEmpty()) map.fitBounds(bounds, 40);
          resolveMissingCoords();
        }).catch(function () { /* map stays hidden; list still works */ });
      }

      // Stores added by the client without lat/lng get geocoded client-side, cached 30 days
      function resolveMissingCoords() {
        if (!geocoder) return;
        var missing = stores.filter(function (s) { return s.lat == null || s.lng == null; });
        missing.forEach(function (s) {
          var key = 'addr_' + fullAddress(s).replace(/\s+/g, '_');
          var cached = cacheGet(key);
          if (cached) { s.lat = cached.lat; s.lng = cached.lng; addLateMarker(s); return; }
          geocoder.geocode({ address: fullAddress(s), region: 'CA' }, function (res, status) {
            if (status === 'OK' && res && res[0]) {
              var loc = res[0].geometry.location;
              s.lat = loc.lat(); s.lng = loc.lng();
              cacheSet(key, { lat: s.lat, lng: s.lng });
              addLateMarker(s);
            }
          });
        });
      }

      function addLateMarker(s) {
        if (!map) return;
        var m = new google.maps.Marker({ map: map, position: { lat: s.lat, lng: s.lng }, title: s.name });
        markers.push(m);
      }

      // Storefront API: fetches ALL store_location entries (250/page), bypassing
      // the 50-entry cap of the Liquid-embedded JSON. Falls back to embedded data on any failure.
      function fetchAllStores(token) {
        var query = 'query Stores($cursor: String) { metaobjects(type: "store_location", first: 250, after: $cursor) {' +
          ' pageInfo { hasNextPage endCursor }' +
          ' nodes {' +
          ' store_name: field(key: "store_name") { value }' +
          ' retailer: field(key: "retailer") { value }' +
          ' address: field(key: "address") { value }' +
          ' city: field(key: "city") { value }' +
          ' province: field(key: "province") { value }' +
          ' postal_code: field(key: "postal_code") { value }' +
          ' latitude: field(key: "latitude") { value }' +
          ' longitude: field(key: "longitude") { value }' +
          ' } } }';
        var all = [];
        function fieldVal(n, k) { return (n[k] && n[k].value) || ''; }
        function numVal(n, k) {
          var v = n[k] && n[k].value;
          var f = v == null || v === '' ? NaN : parseFloat(v);
          return isFinite(f) ? f : null;
        }
        function page(cursor) {
          return fetch('/api/2026-01/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({ query: query, variables: { cursor: cursor } })
          }).then(function (r) { return r.json(); }).then(function (j) {
            var mo = j && j.data && j.data.metaobjects;
            if (!mo) throw new Error('Storefront API error');
            mo.nodes.forEach(function (n) {
              all.push({
                name: fieldVal(n, 'store_name'),
                retailer: fieldVal(n, 'retailer'),
                address: fieldVal(n, 'address'),
                city: fieldVal(n, 'city'),
                province: fieldVal(n, 'province').trim().toUpperCase(),
                postal: fieldVal(n, 'postal_code'),
                lat: numVal(n, 'latitude'),
                lng: numVal(n, 'longitude')
              });
            });
            if (mo.pageInfo.hasNextPage) return page(mo.pageInfo.endCursor);
            return all;
          });
        }
        return page(null);
      }

      function activateInstore() {
        if (instoreActivated) return;
        instoreActivated = true;
        renderGrouped(); // instant render from embedded JSON (first 50)
        var sfToken = (root.getAttribute('data-storefront-token') || '').trim();
        var ready = sfToken
          ? fetchAllStores(sfToken).then(function (all) {
              if (all.length) { stores = all; renderGrouped(); }
            }).catch(function () { /* embedded fallback stays */ })
          : Promise.resolve();
        ready.then(function () {
          if (!apiKey) {
            // No key: hide postal search (distance needs geocoding), keep grouped list + directions links
            form.hidden = true;
            return;
          }
          initMap();
        });
      }

      form && form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearMsg();
        var postal = normalizePostal(input.value);
        if (!postal) { showMsg(root.getAttribute('data-invalid-postal-text')); return; }
        track('store_locator_search', { locator_fsa: postal.slice(0, 3) }); // FSA only — never push full postal
        var cached = cacheGet('postal_' + postal.replace(' ', ''));
        if (cached) { applyOrigin(cached); return; }
        initMap().then(function () {
          if (!geocoder) { showMsg(root.getAttribute('data-not-found-text')); return; }
          geocoder.geocode(
            { componentRestrictions: { country: 'CA', postalCode: postal } },
            function (res, status) {
              if (status === 'OK' && res && res[0]) {
                var loc = res[0].geometry.location;
                var origin = { lat: loc.lat(), lng: loc.lng() };
                cacheSet('postal_' + postal.replace(' ', ''), origin);
                applyOrigin(origin);
              } else {
                showMsg(root.getAttribute('data-not-found-text'));
              }
            }
          );
        });
      });

      function applyOrigin(origin) {
        renderSorted(origin);
        if (map) {
          if (userMarker) userMarker.setMap(null);
          userMarker = new google.maps.Marker({
            map: map,
            position: origin,
            title: 'Your location',
            icon: {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 8, fillColor: '#3c2568', fillOpacity: 1,
              strokeColor: '#fff', strokeWeight: 2
            }
          });
          var nearest = stores.filter(function (s) { return s.lat != null; })
            .sort(function (a, b) { return a.__d - b.__d; })[0];
          var b = new google.maps.LatLngBounds();
          b.extend(origin);
          if (nearest) b.extend({ lat: nearest.lat, lng: nearest.lng });
          map.fitBounds(b, 60);
        }
      }

      resetBtn && resetBtn.addEventListener('click', function () {
        clearMsg();
        input.value = '';
        renderGrouped();
        if (userMarker) { userMarker.setMap(null); userMarker = null; }
        if (map && markers.length) {
          var b = new google.maps.LatLngBounds();
          markers.forEach(function (m) { b.extend(m.getPosition()); });
          map.fitBounds(b, 40);
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-lg-store-locator]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
